import { NgModule } from '@angular/core';
import { AddEditVesselRateDialogComponent } from './add-edit-vessel-rate-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    MatRadioModule,
    MatDialogModule,
    FlexModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    TextMaskModule,
    MatSelectModule,
    CommonModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
  ],
  declarations: [AddEditVesselRateDialogComponent],
  entryComponents: [AddEditVesselRateDialogComponent],
  exports: [AddEditVesselRateDialogComponent],
  providers: [],
})
export class AddEditVesselRateDialogModule {}
